/* @flow */
// $FlowFixMe
import Worker from 'worker-loader!./Worker.js'
import _ from 'lodash'

export type CodeReference = {
  matchedRef: String,
  index: number,
  length: number,
  lineStart: number
}

export type AnalysisResult = {
  vars: Array<string>,
  fieldRefs: Array<CodeReference>,
  flowRefs: Array<CodeReference>,
  semanticComments: Array<CodeReference>,
  apiUsage: Object
}

// Spin up a scheduler with its own dedicated web worker
function getNewScheduler() {
  const worker = new Worker()
  const pendingJobs = []
  let counter = 0

  worker.onmessage = event => {
    // The following assumes worker jobs never overtake each other
    // This should be a valid assumption so long as there is just the one worker thread servicing the queue
    // If a reply arrives to a job that isn't head of the queue, pending jobs prior to that are considered failed
    const reply = event.data
    if (!reply) {
      console.warn('Received empty reply from worker', pendingJobs)
      return
    }
    const matchingPendingIndex = _.findIndex(pendingJobs, p => p.job.jobId === reply.jobId)
    if (matchingPendingIndex === -1) {
      console.warn('No pending job for reply', reply, pendingJobs)
      return
    } else if (matchingPendingIndex > 0) {
      // Jobs before the matching one are considered lost. Remove from queue and reject them
      const lostJobs = pendingJobs.splice(0, matchingPendingIndex)
      console.warn(
        `Out of order reply. This suggests the worker has dropped the ball on ${lostJobs.length} job(s)`
      )
      lostJobs.forEach(lostJob => lostJob.reject({ error: 'No reply from worker' }))
    }
    // Now the replied-to job is first in the queue
    const pendingJob = pendingJobs.shift()
    if (reply.error) pendingJob.reject(reply.error)
    else pendingJob.resolve(reply.result)
  }

  function scheduleJob(job) {
    return new Promise((resolve, reject) => {
      job.jobId = counter++
      pendingJobs.push({ resolve, reject, job })
      worker.postMessage(job)
    })
  }

  function scheduleCodeAnalysis(
    code: string,
    isModernJs: boolean,
    api: Object
  ): Promise<AnalysisResult> {
    const job = { command: 'analyseCode', arg: { code, isModernJs, api }, jobId: -1 }
    return scheduleJob(job)
  }

  return {
    scheduleCodeAnalysis
  }
}

const defaultScheduler = getNewScheduler()

export default {
  defaultScheduler
}
